var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('crypto-browserify'),
    randomBytes = _require.randomBytes,
    pbkdf2 = _require.pbkdf2;

var secp256k1 = require('secp256k1');

var messages = require('./messages.js');

var _require2 = require("eth-lib/lib/hash"),
    keccak256 = _require2.keccak256;

var rlp = require('rlp-encoding');

var stripHexPrefix = require('strip-hex-prefix');

var constants = require('./constants');

var pow = require('./pow');

var Big = require('big.js');

var Uint64BE = require("int64-buffer").Uint64BE;

var _require3 = require('./bloom'),
    createBloomFilter = _require3.createBloomFilter,
    topicToBloom = _require3.topicToBloom;

var BloomFilterManager = require('./bloom').default;

var MessageTracker = require('./message-tracker');

var Envelope = require("./envelope");

var Manager =
/*#__PURE__*/
function () {
  "use strict";

  function Manager(provider, options) {
    _classCallCheck(this, Manager);

    this.provider = provider;
    this.options = options;
    this.keys = {};
    this.subscriptions = {};
    this.messagesTracker = new MessageTracker();
    this.bloomManager = new BloomFilterManager(options.ignoreBloomFilters);
  }

  _createClass(Manager, [{
    key: "executeOnReady",
    value: function executeOnReady(cb) {
      this.onReadyCB = cb;
    }
  }, {
    key: "setupNodes",
    value: function setupNodes(nodes) {
      var _this = this;

      this.nodes = nodes;
      nodes.map(function (n) {
        n.setTracker(_this.messagesTracker);
        n.setBloomManager(_this.bloomManager);
      });
    }
  }, {
    key: "start",
    value: function start() {
      this.listenToProviderEvents();
      this.listenToNodeEvents();
    }
  }, {
    key: "getNode",
    value: function getNode(protocol) {
      return this.nodes.find(function (x) {
        return x.type === protocol;
      });
    }
  }, {
    key: "isReady",
    value: function isReady(protocol) {
      this.getNode(protocol).ready = true;

      if (!this.nodes.filter(function (x) {
        return !x.ready;
      }).length) {
        console.log("Murmur ready");
        if (this.onReadyCB) this.onReadyCB();
      }
    }
  }, {
    key: "listenToProviderEvents",
    value: function listenToProviderEvents() {
      var _this2 = this;

      this.provider.events.on('post', function (payload, cb) {
        var symKeyID = payload.symKeyID,
            pubKey = payload.pubKey,
            sig = payload.sig,
            ttl = payload.ttl,
            topic = payload.topic,
            padding = payload.padding,
            powTime = payload.powTime,
            powTarget = payload.powTarget,
            targetPeer = payload.targetPeer;
        var messagePayload = Buffer.from(stripHexPrefix(payload.payload), 'hex');
        topic = Buffer.from(stripHexPrefix(topic), 'hex');

        if (ttl === 0) {
          ttl = 50; // Default TTL
        }

        var options = {};
        var expiry = Math.floor(new Date().getTime() / 1000.0) + ttl;

        if (!!sig) {
          if (Buffer.isBuffer(sig)) {
            options.from = {
              privKey: "0x" + sig.toString('hex')
            };
          } else {
            options.from = _this2.keys[sig];

            if (!options.from || !options.from.privKey) {
              return cb("No identity found");
            }
          }
        }

        if (pubKey && symKeyID) return cb("Either symKeyID or pubKey should be specified, not both"); // Set symmetric key that is used to encrypt the message

        if (!!symKeyID) {
          if (!topic) return cb("Topic is required");
          if (topic.length > 4) return cb("Topic length is incorrect");
          options.symKey = _this2.keys[symKeyID];
          if (!options.symKey || !options.symKey.symmetricKey) return cb("No symmetric key found");
          if (!messages.validateDataIntegrity(Buffer.from(stripHexPrefix(options.symKey.symmetricKey), "hex"), constants.symKeyLength)) return cb("Invalid symmetric key");
        } else {
          if (!pubKey) return cb("Pubkey is required");
          if (!stripHexPrefix(pubKey).match(/^[0-9A-Fa-f]{130}$/)) return cb("Invalid pubkey");
        }

        var envelope = messages.buildMessage(messagePayload, padding, sig, options, function (err) {
          if (err) console.log(err);
        });

        var dispatchEnvelope = function dispatchEnvelope(err, encryptedMessage) {
          if (err) {
            console.error(err);
            return cb("Error encrypting message");
          }

          var powResult = pow.ProofOfWork(powTarget, powTime, ttl, topic, encryptedMessage, expiry);
          var nonceBuffer = powResult.nonce;
          var non0 = false;
          var val = [];

          for (var i = 0; i < nonceBuffer.length; i++) {
            if (nonceBuffer[i] !== 0) {
              non0 = true;
            }

            if (non0) {
              val.push(nonceBuffer[i]);
            }
          }

          nonceBuffer = Buffer.from(val);
          var msgEnv = [];
          var expiryB = Buffer.alloc(4);
          expiryB.writeUInt32BE(powResult.expiry);
          var ttlB = Buffer.alloc(1);
          ttlB.writeUInt8(ttl);
          msgEnv.push(expiryB);
          msgEnv.push(ttlB);
          msgEnv.push(topic);
          msgEnv.push(encryptedMessage);
          msgEnv.push(nonceBuffer);
          var envelope = new Envelope(msgEnv);

          var devp2p = _this2.getNode('devp2p');

          var libp2p = _this2.getNode('libp2p');

          if (targetPeer) {
            // Mailserver request
            if (devp2p) devp2p.broadcast(msgEnv, targetPeer.toString('hex'), constants.SHH_P2PREQ); // TODO: libp2p mailserver
          } else {
            if (devp2p) {
              devp2p.broadcast(envelope);

              _this2.messagesTracker.push(envelope, 'devp2p');
            }

            if (libp2p) {
              libp2p.broadcast(envelope);

              _this2.messagesTracker.push(envelope, 'libp2p');
            }

            _this2.sendEnvelopeToSubscribers(envelope);
          }
        };

        if (options.symKey) {
          messages.encryptSymmetric(topic, envelope, options, dispatchEnvelope);
        } else {
          messages.encryptAsymmetric(envelope, pubKey, dispatchEnvelope);
        }
      }); // TODO: this needs to refactored to take into account different clients

      this.provider.events.on('subscribe', function (payload, cb) {
        var _minPow = payload._minPow,
            symKeyID = payload.symKeyID,
            privateKeyID = payload.privateKeyID,
            topics = payload.topics,
            _allowP2P = payload._allowP2P;
        var id = randomBytes(constants.keyIdLength).toString('hex');

        _this2.bloomManager.emit('updateFilter', topics);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = topics[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var topic = _step.value;

            if (!_this2.subscriptions[topic]) {
              _this2.subscriptions[topic] = {};
            }

            _this2.subscriptions[topic][id] = {
              privateKeyID: privateKeyID,
              symKeyID: symKeyID
            };
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        cb(null, id);
      });
      this.provider.events.on("markTrustedPeer", function (enode) {
        _this2.getNode('devp2p').addTrustedPeer(enode);
      });
      this.provider.events.on("addPeer", function (url, cb) {
        var urlParts = url.split("@");
        var ipInfo = urlParts[1].split(":");
        var id = Buffer.from(urlParts[0].replace("enode://", ""), "hex");
        var address = ipInfo[0];
        var port = ipInfo[1];

        _this2.getNode('devp2p').addStaticPeer({
          id: id,
          address: address,
          port: port
        }, function (err, data) {
          if (err) {
            cb(err);
          } else {
            cb(null, data);
          }
        });
      });
      this.provider.events.on("requestMessages", function (minPow, message, cb) {
        var peerId = Buffer.from(message.mailserverPeer.split("@")[0].replace('enode://', ''), 'hex');
        var now = parseInt(new Date().getTime() / 1000, 10);
        if (!message.to) message.to = now;
        if (!message.from) message.from = now - 86400; // -24hr

        if (!message.timeout) message.timeout = 30;
        var publicKey = null;
        var payload = rlp.encode([message.from, message.to, createBloomFilter(message), message.limit, null, 1]);

        if (!message.symKeyID) {
          publicKey = Buffer.concat([Buffer.from(4), Buffer.from(peerId, 'hex')]);
        } // TODO: mailserver request. Check how it would work with libp2p


        var envelope = {
          symKeyID: message.symKeyID,
          pubKey: publicKey,
          sig: _this2.getNode('devp2p').privateKey,
          ttl: 50,
          topic: "0x00000000",
          powTime: 1,
          //  TODO: If using default time of 5 secs, peer will disconnect. PoW needs to happen in a separate thread
          powTarget: minPow,
          payload: payload,
          targetPeer: peerId
        };

        _this2.provider.events.emit('post', envelope, cb);
      });
      this.provider.events.on("newKeyPair", function (cb) {
        var id = randomBytes(constants.keyIdLength).toString('hex');
        if (_this2.keys[id]) return cb("key is not unique");
        var privKey = randomBytes(constants.privKeyLength);
        var pubKey = secp256k1.publicKeyCreate(privKey, false);
        _this2.keys[id] = {
          privKey: "0x" + privKey.toString('hex'),
          pubKey: "0x" + pubKey.toString('hex')
        };
        cb(null, id);
      });
      this.provider.events.on("addPrivateKey", function (privKey, cb) {
        var id = randomBytes(constants.keyIdLength).toString('hex');
        if (_this2.keys[id]) return cb("key is not unique");
        privKey = stripHexPrefix(privKey);
        _this2.keys[id] = {
          privKey: "0x" + privKey,
          pubKey: "0x" + secp256k1.publicKeyCreate(Buffer.from(privKey, "hex"), false).toString('hex')
        };
        cb(null, id);
      });
      this.provider.events.on("getPublicKey", function (id, cb) {
        var key = _this2.keys[id];

        if (!key || !key.pubKey) {
          return cb("key not found");
        }

        cb(null, key.pubKey);
      });
      this.provider.events.on("getPrivateKey", function (id, cb) {
        var key = _this2.keys[id];

        if (!key || !key.privKey) {
          return cb("key not found");
        }

        cb(null, key.privKey);
      });
      this.provider.events.on("hasKeyPair", function (id, cb) {
        var key = _this2.keys[id];
        cb(null, !!key && !!key.privKey);
      });

      var deleteKey = function deleteKey(id, cb) {
        if (id.length / 2 !== constants.keyIdLength) {
          var errMsg = "invalid id";
          return cb(errMsg);
        }

        if (_this2.keys[id]) {
          delete _this2.keys[id];
          cb(null, true);
        } else {
          cb(null, false);
        }
      };

      this.provider.events.on("deleteKeyPair", function (id, cb) {
        deleteKey(id, cb);
      });
      this.provider.events.on("addSymKey", function (symmetricKey, cb) {
        var id = randomBytes(constants.keyIdLength).toString('hex');
        if (_this2.keys[id]) return cb("key is not unique");

        if (stripHexPrefix(symmetricKey).length / 2 !== constants.symKeyLength) {
          return cb("wrong key size");
        }

        _this2.keys[id] = {
          symmetricKey: "0x" + stripHexPrefix(symmetricKey)
        };
        cb(null, id);
      });
      this.provider.events.on("newSymKey", function (cb) {
        var id = randomBytes(constants.keyIdLength).toString('hex');
        var symmetricKey = "0x" + randomBytes(constants.symKeyLength).toString('hex');
        if (_this2.keys[id]) return cb("key is not unique");
        _this2.keys[id] = {
          symmetricKey: symmetricKey
        };
        cb(null, id);
      });
      this.provider.events.on("generateSymKeyFromPassword", function (password, cb) {
        var id = randomBytes(constants.keyIdLength).toString('hex');
        if (_this2.keys[id]) return cb("key is not unique");
        pbkdf2(password, "", 65356, constants.symKeyLength, 'sha256', function (err, derivedKey) {
          if (err) return cb(err);
          _this2.keys[id] = {
            symmetricKey: "0x" + derivedKey.toString('hex')
          };
          cb(null, id);
        });
      });
      this.provider.events.on("hasSymKey", function (id, cb) {
        var key = _this2.keys[id];
        cb(null, !!key && !!key.symmetricKey);
      });
      this.provider.events.on("getSymKey", function (id, cb) {
        var key = _this2.keys[id];

        if (!key || !key.symmetricKey) {
          return cb("key not found");
        }

        cb(null, key.symmetricKey);
      });
      this.provider.events.on("deleteSymKey", function (id, cb) {
        deleteKey(id, cb);
      });
    }
  }, {
    key: "sendEnvelopeToSubscribers",
    value: function sendEnvelopeToSubscribers(envelope) {
      var _this3 = this;

      if (this.messagesTracker.isSent(envelope)) return; //console.dir('received message, sending to subscribers...');
      // Preparing data
      // TODO: this data preparation could be part of envelope?

      var nonce = new Uint64BE(new Big(pow.hexStringToDecString(envelope.nonce.toString('hex')))).toBuffer();
      var ttl = typeof envelope.ttl === 'number' ? envelope.ttl : parseInt(pow.hexStringToDecString(envelope.ttl.toString('hex')), 10);
      var calculatedPow = pow.calculatePoW(envelope.expiry, ttl, envelope.topic, envelope.data, nonce);
      var topicSubscriptions = this.subscriptions['0x' + envelope.topic.toString('hex')];

      if (!topicSubscriptions) {
        return;
      }

      var _arr = Object.keys(topicSubscriptions);

      var _loop = function _loop() {
        var subscriptionId = _arr[_i];

        var decryptCB = function decryptCB(err, decrypted) {
          if (!decrypted) return; // console.dir(decrypted.payload.toString());
          //onsole.dir(decrypted.pubKey.toString('hex'));

          _this3.provider.transmit({
            "jsonrpc": "2.0",
            "method": "shh_subscription",
            "params": {
              subscription: subscriptionId,
              result: {
                sig: "0x" + decrypted.pubKey.toString('hex'),
                // recipientPublicKey: null,
                ttl: ttl,
                timestamp: 1498577270,
                // TODO: correct value
                topic: "0x" + envelope.topic.toString('hex'),
                payload: "0x" + decrypted.payload.toString('hex'),
                //padding: decrypted.padding.toString('hex'),
                padding: null,
                pow: calculatedPow,
                hash: envelope.id
              }
            }
          });
        }; // console.dir(">>>>> subscription");


        var keyId = topicSubscriptions[subscriptionId].symKeyID;

        if (!keyId) {
          keyId = topicSubscriptions[subscriptionId].privateKeyID;

          if (_this3.keys[keyId]) {
            var key = Buffer.from(_this3.keys[keyId].privKey.slice(2), 'hex');
            messages.decryptAsymmetric(key, envelope.data, decryptCB);
          }
        } else {
          var _key = Buffer.from(_this3.keys[keyId].symmetricKey.slice(2), 'hex');

          messages.decryptSymmetric(envelope.topic, _key, envelope.data, decryptCB);
        }
      };

      for (var _i = 0; _i < _arr.length; _i++) {
        _loop();
      }
    }
  }, {
    key: "listenToNodeEvents",
    value: function listenToNodeEvents() {
      var _this4 = this;

      var isBridge = this.options.isBridge;

      var handleMessage = function handleMessage(protocol) {
        return function (envelope) {
          _this4.messagesTracker.push(envelope, protocol);

          if (isBridge) _this4.getNode(protocol).broadcast(envelope);

          _this4.sendEnvelopeToSubscribers(envelope);
        };
      };

      if (this.getNode('devp2p')) {
        this.getNode('devp2p').events.on('ready', function () {
          _this4.isReady('devp2p');
        });
        this.getNode('devp2p').events.on('shh_message', handleMessage('libp2p'));
      }

      if (this.getNode('libp2p')) {
        this.getNode('libp2p').events.on('ready', function () {
          _this4.isReady('libp2p');
        });
        this.getNode('libp2p').events.on('shh_message', handleMessage('devp2p'));
      }
    }
  }]);

  return Manager;
}();

module.exports = Manager;